import { render } from "./ChannelGrid.vue?vue&type=template&id=4c3c32e7&scoped=true"
import script from "./ChannelGrid.vue?vue&type=script&lang=js"
export * from "./ChannelGrid.vue?vue&type=script&lang=js"

import "./ChannelGrid.vue?vue&type=style&index=0&id=4c3c32e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3c32e7"]])

export default __exports__